const icon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 16 16"
	>
		<path fill="#f63d3d" d="M0 4v8h16v-8h-16zM15 11h-14v-4h14v4z" />
		<path fill="#f63d3d" d="M0 0h16v3h-16v-3z" />
		<path fill="#f63d3d" d="M0 13h16v3h-16v-3z" />
	</svg>
);

export default icon;
